import Footer from "../../common/footer/footer.tsx";
import "./privacyAndPolicy.css";

const PrivacyPolicy = () => {
  return (
    <>
      <div className='privacy-container'>
        <div className='privacy-card'>
          <h1 className='privacy-title'>Privacy Policy</h1>

          <p className='privacy-subtitle'>
            <strong>Uyirththunai</strong>
          </p>

          <p className='privacy-intro'>
            At Uyirththunai, we are deeply committed to protecting your privacy and handling your personal information
            with care, transparency, and respect. This Privacy Policy explains what information we collect, how we use
            it, and your rights regarding that information.
            <br />
            <br />
            By registering or using Uyirththunai, you acknowledge that you have read and agreed to the practices described
            in this Privacy Policy.
          </p>

          <div className='privacy-section'>
            <h2>1. Information We Collect</h2>

            <p>We collect the following types of information:</p>

            <ul>
              <li>
                <strong>Personal Information:</strong> Name, date of birth, gender, religion, caste, nationality, and
                contact details provided during registration.
              </li>

              <li>
                <strong>Profile Information:</strong> Educational background, profession, family details, partner
                preferences, and photographs uploaded by you.
              </li>

              <li>
                <strong>Identity Documents:</strong> Where required for verification purposes.
              </li>
            </ul>
          </div>

          <div className='privacy-section'>
            <h2>2. How We Use Your Information</h2>

            <p>Your information is used to:</p>

            <ul>
              <li>Create and manage your account and profile.</li>
              <li>Suggest compatible matches based on your preferences.</li>
              <li>Communicate with you regarding your account, updates, and support.</li>
              <li>Improve our platform through research and analysis.</li>
              <li>Ensure compliance with our Terms & Conditions and prevent fraud or misuse.</li>
              <li>Send relevant notifications and, where opted in, promotional communications.</li>
            </ul>
          </div>

          <div className='privacy-section'>
            <h2>3. Sharing of Information</h2>

            <p>
              Uyirththunai does not sell your personal information to third parties. We may share your information only in
              the following circumstances:
            </p>

            <ul>
              <li>
                With other registered members as part of the matchmaking process, in accordance with your privacy
                settings.
              </li>

              <li>When required by law, court order, or government authority.</li>

              <li>To protect the rights, safety, or property of Uyirththunai or its members.</li>
            </ul>
          </div>

          <div className='privacy-section'>
            <h2>4. Your Profile Visibility</h2>

            <p>
              Information you include in your profile is visible to other registered members of Uyirththunai. You are
              encouraged to exercise discretion about the personal details you choose to share publicly. Uyirththunai
              cannot control how other members may use information you voluntarily display on your profile.
            </p>
          </div>

          <div className='privacy-section'>
            <h2>5. Your Rights & Choices</h2>

            <p>As a registered member, you have the right to:</p>

            <ul>
              <li>Access and update your personal information at any time through your account settings.</li>

              <li>Request deactivation or deletion of your account by contacting our support team.</li>

              <li>Opt out of promotional communications at any time.</li>
            </ul>

            <p>
              Please note that deactivating your account will remove your access to the platform and your profile from
              public view.
            </p>
          </div>

          <div className='privacy-section'>
            <h2>6. Data Security</h2>

            <p>
              Uyirththunai implements appropriate technical and organizational security measures to protect your personal
              information from unauthorized access, disclosure, or misuse. However, no online platform can guarantee
              absolute security, and we encourage you to take personal precautions such as keeping your login
              credentials confidential.
            </p>
          </div>


          <div className='privacy-section'>
            <h2>7. Children's Privacy</h2>

            <p>
              Uyirththunai is strictly for adults aged 18 and above. We do not knowingly collect personal information from
              anyone under the age of 18. If we become aware that a minor has registered, we will promptly deactivate
              and delete their account and associated data.
            </p>
          </div>

          <div className='privacy-section'>
            <h2>8. Third-Party Links</h2>

            <p>
              Our platform may contain links to third-party websites. Uyirththunai is not responsible for the privacy
              practices or content of those external sites. We encourage you to review their privacy policies before
              sharing any personal information.
            </p>
          </div>

          <div className='privacy-section'>
            <h2>9. Changes to This Policy</h2>

            <p>
              We may update this Privacy Policy from time to time to reflect changes in our practices or legal
              requirements. We recommend checking this page periodically. Continued use of Uyirththunai after any changes
              constitutes your acceptance of the updated policy.
            </p>
          </div>

          <div className='privacy-section'>
            <h2>10. Contact Us</h2>

            <p>
              If you have any questions, concerns, or requests regarding this Privacy Policy, please reach out to our
              support team through the contact details available on our website.
            </p>

            <p>
              <strong>Uyirththunai — Connecting Hearts, Building Futures.</strong>
            </p>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default PrivacyPolicy;
